import { render, staticRenderFns } from "./StudioIndexPageTable.vue?vue&type=template&id=6ca33a56&scoped=true"
import script from "./StudioIndexPageTable.vue?vue&type=script&lang=js"
export * from "./StudioIndexPageTable.vue?vue&type=script&lang=js"
import style0 from "./StudioIndexPageTable.vue?vue&type=style&index=0&id=6ca33a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca33a56",
  null
  
)

export default component.exports